// @flow

import * as React from 'react';

export type SetableSetFunc<T> = (?$Shape<T>) => any;

export type SetableProps<T> = {|
  childProps?: ?T,
  children?: (T, SetableSetFunc<T>) => React.Node,
|};

/**
   A generic stateful component that passes its setState function to children. This allows simple
   stateful components to be built from stateless components.
 */
class Setable<T> extends React.Component<SetableProps<T>, T> {
  constructor(props: SetableProps<T>) {
    super(props);

    this.state = { ...(props.childProps || {}: Object) };
  }

  render() {
    if (!this.props.children) {
      return null;
    }
    return this.props.children(this.state, (x: any) => this.setState(x));
  }
}

export default Setable;
